import { configureStore } from '@reduxjs/toolkit'
import { callApi } from './features/CallApi'
import tokenReducer from './features/tokenSlice'
import refreshTokenReducer from './features/refreshTokenSlice'
import selectionReducer from './features/selectionSlice'
import { setupListeners } from '@reduxjs/toolkit/dist/query'
// Or from '@reduxjs/toolkit/query/react'

export const store = configureStore({
  reducer: {
    token: tokenReducer,
    refreshToken: refreshTokenReducer,
    selection: selectionReducer,
    // Add the generated reducer as a specific top-level slice
    [callApi.reducerPath]: callApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(callApi.middleware),
})

setupListeners(store.dispatch)